<template>
  <div style="padding: 10px">正在加载中，如长时间出现此页面，请 <a @click="jump()">点击刷新</a>。</div>
</template>

<script>
import {v4 as uuidv4} from 'uuid';

export default {
  name: "Download",
  created() {
    this.jump();
  },
  mounted() {
    this.jump();
  },
  methods: {
    // 跳转到下载页面
    jump() {
      let search = location.search;
      if (!search) {
        search = "?1=1"
      }
      location.href = "/download/index.html" + search + "&key=" + (uuidv4().toString().replace(/-/g, ''));
    }
  },
}

</script>

<style scoped>
a {
  color: #00a5f6;
}
</style>
